export default __webpack_public_path__ + "static/media/hbs-k-cbb-poster-2.1102ffe1.jpg";